import React from 'react';
import { Link, useParams } from 'react-router-dom';

const LocalizedLink = ({ to, ...props }) => {
  const { lang } = useParams();
  const localizedTo = typeof to === 'string' && to.startsWith('/')
    ? `/${lang}${to}`
    : to;
  return <Link to={localizedTo} {...props} />;
};

export default LocalizedLink;
